import { TreeSelect } from 'antd';
import { useEffect, useState } from 'react';
import { arrayCommon } from '../../helpers/common';
import { ChucNangSelectBox } from '../../models/chucnang/ChucNang';
import { layDanhSachChucNangSelectTree } from '../../services/chucnang';

const ChucNangSelectTree = ({ name, value, optionAll, noChoose, onChange }: { name: string, value: number, optionAll?: boolean, noChoose?: boolean, onChange: (e: any) => void }) => {
    const [data, setData] = useState<Array<ChucNangSelectBox>>([]);
    const dsChucNang = async () => {
        try {
            let rs = await layDanhSachChucNangSelectTree();
            if ((rs || []).length == 0) {
                rs = [
                    {
                        value: -1,
                        title: "--Không có dữ liệu--",
                        children: []
                    },
                ];
            }
            if (optionAll) {
                rs.unshift({
                    "value": 0,
                    "title": "--Tất cả--",
                    "children": []
                });
            }
            if (noChoose) {
                rs.unshift({
                    "value": 0,
                    "title": "--Không có chức năng cha--",
                    "children": []
                });
            }
            setData(rs);
            let opt = arrayCommon.findByValue(rs, value);
            if (opt == null || opt == undefined) {
                onChange({
                    target: {
                        name: name,
                        value: rs[0].value
                    }
                });
            }
        }
        catch (error: any) {
        };
    }

    useEffect(() => {
        dsChucNang();
    }, []);
    return (
        <TreeSelect
            style={{ width: '100%' }}
            showSearch={true}
            filterTreeNode={function (search, item: any) {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={data}
            placeholder="Chọn chức năng cha"
            treeDefaultExpandAll={false}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
        />
    );
};

export default ChucNangSelectTree;
